import React from "react";

// Import Ionic
import { IonCard, IonCardContent, IonCardHeader, IonCardTitle, IonCol, IonRow } from "@ionic/react";

// Import Styles
import classNames from "classnames/bind";
import styles from "./OrderSummary.module.scss";

import { currencyTransform } from "../../providers/Redux/Reducers/reducers2";
import { useTranslation } from "react-i18next";

interface IOrderSummaryTotal {
  productTotal: string | number;
  deliveryAmount: string | number;
  discount: string | number;
  title: string;
}

const cx = classNames.bind(styles);

const OrderSummaryTotal: React.FC<IOrderSummaryTotal> = ({
  productTotal,
  discount,
  deliveryAmount,
  title,
}) => {
  const { t } = useTranslation();
  return (
    <IonCard className={cx("orderSummary")}>
      <IonCardHeader className={cx("orderSummaryHeader")} color="primary">
        <IonCardTitle className={cx("orderSummaryTitle")}>{title}</IonCardTitle>
      </IonCardHeader>
      <IonCardContent className={cx("ion-padding ion-margin-top", "orderSummaryDescription")}>
        <IonRow>
          <IonCol size="6">{t("Products Price")}</IonCol>
          <IonCol className="ion-text-right" size="6">
            {currencyTransform(productTotal)}
          </IonCol>
        </IonRow>

        {!!deliveryAmount && (
          <IonRow>
            <IonCol size="6">{t("Shipping Cost")}</IonCol>
            <IonCol className="ion-text-right" size="6">
              {currencyTransform(deliveryAmount)}
            </IonCol>
          </IonRow>
        )}

        {!!discount && (
          <IonRow>
            <IonCol size="6">{t("Discount")}</IonCol>
            <IonCol className="ion-text-right" size="6">
              {currencyTransform(discount)}
            </IonCol>
          </IonRow>
        )}

        <IonRow>
          <IonCol size="6">{t("Total")}</IonCol>
          <IonCol className="ion-text-right" size="6">
            <strong>{currencyTransform(Number(productTotal) - Number(discount) + Number(deliveryAmount))}</strong>
          </IonCol>
        </IonRow>
      </IonCardContent>
    </IonCard>
  );
};

export default OrderSummaryTotal;
